if (window.location.pathname === "/collections/crossword-gift-vouchers") {
  window.location.href = "https://www.crossword.in/collections/gift-cards";
}

let collectionsWithRank = new Map([
  // ['new-noteworthy-2', 50],
  // ['new-noteworthy-fiction-2', 50],
  // ['new-noteworthy-non-fiction-2', 50],
  // ['new-noteworthy-business-management-1', 50],
  // ['new-noteworthy-kids-3', 50],
  // ['new-noteworthy-young-adults-1', 50],
  // ['top-51', 50],
  // ['new-noteworthy-fiction-2', 50],
  // ['non-fiction-top-51', 50],
  // ['business-management-top-50', 50],
  // ['kids-top-51', 50],
  // ['young-adults-top-51', 50],
  // ['crossword-recommends', 50],
  // ['books', 50],
  // ['fiction', 50],
  // ['non-fiction-1', 50],
  // ['business-management-1', 50],
  // ['kids-books', 50],
  // ['young-adult', 50],
  // ['general-and-literary-fiction', 50],
  // ['fiction-top-51', 50]
]);

function extractCollectionName(url) {
  // Define a regular expression pattern to match the collection name
  const pattern = /\/collections\/([^?/]+)/;

  // Use the RegExp.exec method to extract the collection name
  const matches = pattern.exec(url);

  // Check if there is a match and return the collection name (group 1 in the regex match)
  if (matches && matches[1]) {
    return matches[1];
  } else {
    // Return a default value or handle the case where the pattern doesn't match
    return null;
  }
}

function findProductRank(value) {
  const len = value.length;
  if (len > 3) {
    const number = value[len - 3] + value[len - 2] + value[len - 1];
    // console.log(number);
    return parseInt(number, 10);
  }

  return NaN;
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (data.filters.type == "AUTOCOMPLETE_DEFAULT") {
        data.filters.sort = [
          {
            field: "relevance",
            order: "asc",
          },
          {
            field: "product_top-6_sortOrder:float",
            order: "asc",
          },
        ];
      }
      return data;
    }
  );

  // Removing price filter from gift-cards collection
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log("Gift-card ==>",payload);
      // console.log(wizzyConfig.common.collectionHandle==='gift-cards');
      if (wizzyConfig.common.collectionHandle === "gift-cards") {
        payload.response.payload.facets =
          payload.response.payload.facets.filter(
            (facet) => facet.label !== "Price"
          );
      }
      return payload;
    }
  );
  let wizzyEvents2 = function () {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        console.log("event1");
        return data;
      }
    );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        console.log("event2");
        return data;
      }
    );
  };

  window.onWizzyLoaded.push(wizzyEvents2);
  let wizzyEvents1 = function () {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        console.log("event3");
        return data;
      }
    );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
        if (
          typeof window.iwishCheckColl !== "undefined" &&
          typeof window.iwishCheckColl === "function"
        ) {
          window.iwishCheckColl();
        }
        $(".iWishAddColl").on("click", function (e) {
          console.log("Wish Btn is clicked");
          e.preventDefault();
          var iWishvId = $(this).attr("data-variant");
          console.log(iWishvId);
          window.iwish_addCollection($(this), iWishvId);
          // return false; // This line is redundant; returning false already prevents the default action.
        });

        console.log(data, "event4");
        return data;
      }
    );
  };

  window.onWizzyLoaded.push(wizzyEvents1);

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      console.log(data, "<<<before init");
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.general.minQueryLength = 1;

      data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: ".main-search__form .main-search__input",
        type: "search",
      };
      data.search.configs.noProductsFound.defaultPool.data.productsCount = 50;
      var currentURL = window.location.href;
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("main");
      if (currentURL.includes("/collection")) {
        const identifiers = data.common.lazyDOMConfig.contentDOMIdentifiers;
        const indexToRemove = identifiers.indexOf("main");

        if (indexToRemove !== -1) {
          identifiers.splice(indexToRemove, 1);
        }
      }
      // data.common.lazyDOMConfig.contentDOMIdentifiers = ["main"];

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      $(".wizzy-collection-des").css({
        display: "none",
      });
      return data;
    }
  );

  $(document).on("click", " .wizzy-apply-all-button", (e) => {
    $(".wizzy-filters-bg").click();
  });

  function isPresentInURL(params) {
    let url = window.location.href;
    return url.includes(params);
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      data.filters.attributeFacetValuesLimit = 50;
      if (window.location.href.includes("/collection")) {
        data.filters.showOOSProductsInOrder = "true";
      }
console.log("data4444",data);
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 50;
      // console.log(data);

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    }
  );
  // const inputFields = document.querySelectorAll(".wizzy-search-input");
  // console.log(inputFields)=
  //  inputFields.forEach((inputField) => {
  //    inputField.addEventListener("input", () => {
  //      setTimeout(() => {
  //        // console.log("inside input")
  //        const viewMoreButton = document.querySelector(
  //          "button.btn.btn--small.wizzy-autocomplete-top-products-view-more"
  //        );
  //        if (inputField.value.length === 0 && viewMoreButton) {
  //          // viewMoreButton.classList.add("wizzy-display-none");
  //          viewMoreButton.style.display = "none";
  //        } else if (viewMoreButton) {
  //          // viewMoreButton.classList.add("wizzy-display-block");
  //          viewMoreButton.style.display = "block";
  //        }
  //      }, 1000);
  //    });
  //  });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // // Get the input element by its class name
      // var inputElement = document.querySelector(".wizzy-search-input");

      // // Check the length of the input value
      // var inputValueLength = inputElement.value.length;

      // // Output the length to the console
      // console.log("Input value length: " + inputValueLength);

      let currentURL = window.location.href;
      data.forEach((product) => {
        let attributes = product.attributes;
        let author = "";
        let dis = 0;
        attributes.forEach((attribute) => {
          if (attribute.id == "product_books_author_1_custom") {
            author = attribute.values[0].value[0];
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "10%OFF"
          ) {
            dis = 10;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "15%OFF"
          ) {
            dis = 15;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "20%OFF"
          ) {
            dis = 20;
          }
          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "25%OFF"
          ) {
            dis = 25;
          }

          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            (attribute.values[0].value[0] == "30%OFF" ||
              attribute.values[0].value[0] == "30% OFF")
          ) {
            dis = 30;
          }

          if (
            attribute.id == "product_value_tags_discount_wizzy_backend" &&
            attribute.values[0].value[0] == "50%OFF"
          ) {
            dis = 50;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("30%OFF")
          ) {
            dis = 30;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("25%OFF")
          ) {
            dis = 25;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("20%OFF")
          ) {
            dis = 20;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("15%OFF")
          ) {
            dis = 15;
          }

           if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("10%OFF")
          ) {
            dis = 10;
          }

          if (
            attribute.id == "product_tags" &&
            attribute.values[0].value[0].includes("50%OFF")
          ) {
            dis = 50;
          }

          if (
            attribute.id == "product_tags" &&
            (attribute.values[0].value[0].includes("Preorder") ||attribute.values[0].value[0].includes("pre-order"))
          ) {
            product.preorder=true;
            console.log("======>coming")
          }
          // if(attribute.id == "product_tags")
          // {
          //   console.log(attribute.values[0].value[0],"pppppppppppppppppppppppp");
          // }
        });

        product.author = author;
        if (product.price) product.price = product.price.split(".")[0];
        if (product.sellingPrice)
          product.newSellingPrice = product.sellingPrice.split(".")[0];

        // console.log(product.sellingPrice,"<<pp=======")
        let sellingPrice = Number(
          parseFloat(product.sellingPrice.replace(/,/g, ""))
        );
        // console.log(sellingPrice - sellingPrice * 0.1,"<<=======")

        if (dis === 10) {
          console.log(String(sellingPrice - sellingPrice * 0.1), "String");
          // let temp=
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.1 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 10;
        }
        if (dis === 15) {
          console.log(String(sellingPrice - sellingPrice * 0.15), "String");
          // let temp=
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.15 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 15;
        }

        if (dis === 20) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.2 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 20;
        }

        if (dis === 25) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.25 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 25;
        }

        if (dis === 30) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.3 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 30;
        }

        if (dis === 50) {
          product.newSellingPrice = Number(
            String(sellingPrice - sellingPrice * 0.5 + 0.0).split(".")[0]
          ).toLocaleString();
          product.discountPercentage = 50;
        }
      });


      data.forEach(product => {
        product.giftCardAvailable = false;
        if (product.attributes) {
            product.attributes.forEach(attribute => {
                if(attribute.id === "product_product_type") {
                    if(attribute.values[0].value[0] && attribute.values[0].value[0] === "qwikcilver_gift_card") {
                      // console.log(attribute.values[0].value[0]);
                      product.giftCardAvailable = true;
                      product.url = "https://www.crossword.in/products/crossword-gift-card"
                    }
                  }
              })
            }
        })
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // let currentURL = window.location.href;

      // if (currentURL.includes("collections")) {
      //   let currentURL = window.location.href;
      //   let collectionName = extractCollectionName(currentURL);
      //   if (collectionName) {
      //     let topIds = window.wizzyCurrentTopCollectionProducts;
      //     console.log(data, topIds);
      //     data.forEach((product) => {
      //       if (product.groupId === "" || product.groupId === null) {
      //         product.attributes.forEach((attr) => {
      //           if (attr.id === "product_variant_ids") {
      //             product.singleVarientGroupId = product.id;
      //             product.id = attr.values[0].value[0];
      //           }
      //         });
      //       }

      //       let productId = product.groupId
      //         ? product.groupId
      //         : product.singleVarientGroupId;
      //       let pos = topIds.indexOf(productId.toString());
      //       if (pos >= 0 && pos <= collectionsWithRank.get(collectionName)) {
      //         product.rank = pos + 1;
      //       }
      //     });
      //   }
      // }

      // let n = data.length;

      // setTimeout(function() {
      //   console.log(data, "<===after 2 sec");
      //   let allData = JSON.parse(JSON.stringify(data));
      //   console.log(allData[0].id,allData[0].singleVarientGroupId);
      // }, 2000);

      // console.log(data,data[0].id,data.singleVarientGroupId);
      // for(let i = 0; i < n; i++) {
      //   console.log(data[i].name);
      // }

      return data;
    }
  );
  $(document).on("submit", ".wizzy-cart-form", function (event) {
    event.preventDefault();

    var form = $(this);
    var id = form.find('input[name="id"]').val();
    var quantity = form.find('input[name="quantity"]').val();

    console.log(quantity, "<<<=======");
    if (quantity != "0") {
      console.log(quantity, "<<<=======");
      var payload = {
        id: id,
        quantity: 1,
      };

      $.ajax({
        url: "https://www.crossword.in/cart/add.js",
        method: "POST",
        data: JSON.stringify(payload),
        dataType: "json",
        contentType: "application/json", // Set the Content-Type header
        success: function (response) {
          console.log("POST request successful:", response);
        },
        error: function (error) {
          console.error("POST request failed:", error);
        },
      });

      console.log("prevent default");
      setTimeout(function () {
        theme.updateCartSummaries(true);
      }, 500);
    }
  });
  $(document).on("click", ".product-item-author", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    let str = event.target.innerText;
    let authName = "";
    for (let i = 0; i < str.length; i++) {
      if (str[i] == " " && i > 0 && i < str.length - 1) {
        // Replace space between characters
        authName += "-";
      } else {
        authName += str[i].toLowerCase();
      }
    }
    window.location.href = `https://www.crossword.in/collections/${authName}`;
    console.log(event.target.innerText, "<== will not happen.");
  });

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-empty-results");
  changeTemplate("wizzy-collection-empty-results");

  if (document.documentElement.clientWidth > 768) {
    changeTemplate("wizzy-autocomplete-topproducts");
  } else {
    const oldDiv = document.getElementById("wizzy-autocomplete-topproducts");
    const newDiv = document.getElementById(
      "mobile-wizzy-autocomplete-topproducts-new"
    ).text;

    oldDiv.text = newDiv;

    changeTemplate("wizzy-search-wrapper");
  }
};

const changeTemplate = function (div) {
  console.log(div);
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;

  oldDiv.text = newDiv;
};
